var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',[_c('Jumbotron'),_vm._v(" "),_c('RowList',{attrs:{"greetings":_vm.greetings.content}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b8debe","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Greetings.vue
// module id = 133
// module chunks = 0